export enum ButtonType {
    Cancel = 0,
    Primary = 1,
    Secondary = 2,
    Delete = 3,
    Back = 4,
    Succes = 5,
    Invert = 6,
    Icon = 7,
}

export enum InputType {
    Default = 0,
    Filtered = 1,
    LessPadding = 2,
    NumberNav = 3,
    CheckBox = 4,
    TextArea = 5,
    SearchInput = 6
}

export enum TableType {
    Default = 0,
    TvLayout = 1,
    FixedHeight = 2,
    DoubleSticky = 3,
}